import React from "react";

export const LAYER_META = {
  1: { short: "L1", name: "Surface Waste", color: "#0369a1", bg: "#e0f2fe" },
  2: { short: "L2", name: "Configuration", color: "#15803d", bg: "#dcfce7" },
  3: { short: "L3", name: "Application", color: "#b45309", bg: "#fef3c7" },
  4: { short: "L4", name: "Data Lifecycle", color: "#6d28d9", bg: "#ede9fe" },
  5: { short: "L5", name: "Architectural", color: "#b91c1c", bg: "#fee2e2" },
};

export default function LayerBadge({ layer, showName = false }) {
  const m = LAYER_META[layer];
  if (!m) return <span className="text-muted-foreground text-xs">—</span>;
  return (
    <span
      data-testid={`layer-badge-${layer}`}
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-sm text-[10px] font-semibold uppercase tracking-[0.08em]"
      style={{ color: m.color, backgroundColor: m.bg }}
      title={`Layer ${layer} · ${m.name}`}
    >
      {m.short}
      {showName && <span className="normal-case tracking-normal">· {m.name}</span>}
    </span>
  );
}
